import { lenisInstance } from '../scroll';

async function fetchDownloads(url) {
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
        });
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
}

export default () => ({
    downloads: [],
    selectedCategories: [],
    searchQuery: '',
    fromMonth: '',
    fromYear: '',
    toMonth: '',
    toYear: '',
    currentPage: 1,
    pageSize: 10,

    async init() {
        try {
            await this.applyFilters();
        } catch (error) {
            console.error(error);
        }
    },

    async fetchFilteredDownloads() {
        let apiUrl = '/wp-json/download/v1/announcement';
        const queryParams = [];

        if (this.searchQuery) {
            queryParams.push(`search=${encodeURIComponent(this.searchQuery)}`);
        }

        if (this.fromMonth && this.fromYear) {
            queryParams.push(`from_month=${encodeURIComponent(this.fromMonth)}`);
            queryParams.push(`from_year=${encodeURIComponent(this.fromYear)}`);
        }

        if (this.toMonth && this.toYear) {
            queryParams.push(`to_month=${encodeURIComponent(this.toMonth)}`);
            queryParams.push(`to_year=${encodeURIComponent(this.toYear)}`);
        }

        if (this.selectedCategories.length > 0) {
            const categories = this.selectedCategories.join(',');
            queryParams.push(`categories=${encodeURIComponent(categories)}`);
        }

        if (queryParams.length > 0) {
            apiUrl += '?' + queryParams.join('&');
        }

        return fetchDownloads(apiUrl);
    },

    async applyFilters() {
        try {
            this.downloads = await this.fetchFilteredDownloads();
            this.currentPage = 1; // Reset current page when applying filters
        } catch (error) {
            console.error(error);
        }
    },

    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }

        this.handleScroll();
    },

    prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
        }

        this.handleScroll();
    },

    get totalPages() {
        return Math.ceil(this.downloads.length / this.pageSize);
    },

    get paginatedDownloads() {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        return this.downloads.slice(startIndex, endIndex);
    },

    jumpToPage(page) {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
        }

        this.handleScroll();
    },

    handleScroll() {
        const target
            = document.querySelector('.download-row-filter-wrap');
        if (target) {
            lenisInstance.scrollTo(target.offsetTop);
        }
    }
});